module.exports = __webpack_public_path__ + "static/img/background.7b1d7cd4.png";